export default "__VITE_ASSET__e3f7ae3e__"